module.exports = __webpack_public_path__ + "static/media/bishopernestpalmer.e104d25c.svg";